import EmailIcon from '@atlaskit/icon/core/email';
import * as React from 'react';

export function SvgMail() {
  return <EmailIcon label="" testId="ads-refreshed-icon" />;
}
